import getCookie from '@utils/getCookie';
import _axios, { type CustomAxiosInstance } from 'axios';
import { objectToFormData } from 'pano-utils';
import { getAppKey } from './getAppKey';

function redirectToLogin() {
  const current = window.location.origin + window.location.pathname;
  window.location.replace(`/login?redirect=${current}`);
}

const axios: CustomAxiosInstance = _axios.create();

axios.defaults.withCredentials = true;
axios.interceptors.request.use(
  (config) => {
    if (
      config.method &&
      config.method.toLowerCase() === 'post' &&
      !(config.data instanceof Blob)
    ) {
      config.data = objectToFormData(config.data);
    }

    config.headers.set('App-Key', getAppKey());
    config.headers.set('App-Authorization', getCookie());

    return config;
  },
  (error) => Promise.reject(error)
);

export const responseInterceptor = axios.interceptors.response.use(
  (response) => {
    const { data } = response;
    if (!data) return Promise.reject(new Error('Response data error!'));
    if (!data.success) return Promise.reject(new Error(data.message));
    return data.data;
  },
  (error) => {
    if (error.response && error.response.status === 614) {
      return Promise.reject(new Error('Response data error!'));
    }
    if (error.response && error.response.status === 401) {
      redirectToLogin();
      return Promise.reject(new Error('登录失效，请重新登录后继续使用'));
    }
    return Promise.reject(error);
  }
);

export default axios;
